<mat-drawer-container class="sidenav-container">
  @if (isLoggedIn && !(fullscreen$ | async) && !isNavbarProhibited) {
    <mat-drawer
      #sidenav
      [ngClass]="{
        'left-side-nav': sideNavState === 'full' || sideNavState === 'mobile',
        'left-side-nav-icon': sideNavState === 'slim',
      }"
      [opened]="
        sideNavState === 'full' || sideNavState === 'slim' || sidenavOpen
      "
      [mode]="sideNavState === 'mobile' ? 'over' : 'side'"
    >
      <div class="fixed-nav">
        <app-side-nav-menu
          [sidenavState]="sideNavState"
          (toggleDesktopSidenav)="toggleDesktopSidenav()"
          (closeSidenav)="toggleSidenav()"
          (logout)="logout()"
        ></app-side-nav-menu>
      </div>
    </mat-drawer>
  }

  <mat-drawer-content>
    <!-- MAIN APP CONTENT -->
    <main class="content mx-auto" role="main">
      <router-outlet #outlet="outlet"></router-outlet>
    </main>

    @if (!isLoggedIn) {
      <app-footer [showPaymentImages]="isPaymentImages"></app-footer>
    } @else if (isAccountPage) {
      <app-footer
        position="relative"
        background="#2222221c"
        text="#333"
      ></app-footer>
    }
  </mat-drawer-content>
</mat-drawer-container>

<app-terms-and-conditions-modal
  [isOpen]="isTCModalOpen"
  (close)="closeTCModal()"
>
</app-terms-and-conditions-modal>

@if (isLoggedIn) {
  <app-results-day-modal></app-results-day-modal>
}
